import React from "react";
import { HiOutlineMoon, HiOutlineSun } from "react-icons/hi";
import { useTheme } from "../../contexts/ThemeContext";

// Chave claro/escuro do cabeçalho. O estado mora no ThemeProvider (grava em
// localStorage "relinq.theme"), então a escolha persiste entre sessões.
const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label="Alternar tema escuro"
      title={isDark ? "Tema escuro ativo" : "Ativar tema escuro"}
      onClick={toggleTheme}
      className={`relative inline-flex h-7 w-[52px] shrink-0 items-center rounded-full border transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#e45412]/50 ${
        isDark
          ? "border-[#46415A] bg-[#46415A] hover:border-[#FF6A21]/55"
          : "border-orange-200 bg-orange-50"
      } ${className}`}
    >
      <HiOutlineSun
        aria-hidden="true"
        className={`absolute left-1.5 h-3.5 w-3.5 transition-opacity ${
          isDark ? "opacity-40 text-[#F4F2F8]" : "opacity-0"
        }`}
      />
      <HiOutlineMoon
        aria-hidden="true"
        className={`absolute right-1.5 h-3.5 w-3.5 transition-opacity ${
          isDark ? "opacity-0" : "opacity-60 text-[#e45412]"
        }`}
      />
      <span
        className={`inline-flex h-5 w-5 transform items-center justify-center rounded-full shadow transition-transform duration-200 ${
          isDark
            ? "translate-x-[26px] bg-[#FF6A21] text-[#1b1823]"
            : "translate-x-[3px] bg-[#e45412] text-white"
        }`}
      >
        {isDark ? (
          <HiOutlineMoon aria-hidden="true" className="h-3 w-3" />
        ) : (
          <HiOutlineSun aria-hidden="true" className="h-3 w-3" />
        )}
      </span>
    </button>
  );
};

export default ThemeToggle;
